let chapterlist = {
  sampledata: [
    {
      jsonb_agg: [
        {
          category: "Regular event stages",
          chapters: [
            {
              text: "Monday Stage",
              value: "Monday Stage",
            },
            {
              text: "Tuesday Stage",
              value: "Tuesday Stage",
            },
            {
              text: "Wednesday Stage",
              value: "Wednesday Stage",
            },
            {
              text: "Thursday Stage",
              value: "Thursday Stage",
            },
            {
              text: "Friday Stage",
              value: "Friday Stage",
            },
            {
              text: "Weekend Stage (Old)",
              value: "Weekend Stage (Old)",
            },
            {
              text: "Cat Ticket Chance!",
              value: "Cat Ticket Chance!",
            },
            {
              text: "Siege of Hippoe!",
              value: "Siege of Hippoe!",
            },
            {
              text: "Autumn = Sports Day (unused)",
              value: "Autumn = Sports Day (unused)",
            },
            {
              text: "Loving Labour",
              value: "Loving Labour",
            },
            {
              text: "Jingle Cat Bell",
              value: "Jingle Cat Bell",
            },
            {
              text: "Happy New Year ?",
              value: "Happy New Year ?",
            },
            {
              text: "Ritual Happiness",
              value: "Ritual Happiness",
            },
            {
              text: "Bears be Bare",
              value: "Bears be Bare",
            },
            {
              text: "Crimson Catastrophe",
              value: "Crimson Catastrophe",
            },
            {
              text: "Heaven of Darkness",
              value: "Heaven of Darkness",
            },
            {
              text: "Peerless",
              value: "Peerless",
            },
            {
              text: "The Crazed Cat",
              value: "The Crazed Cat",
            },
            {
              text: "The Crazed Tank",
              value: "The Crazed Tank",
            },
            {
              text: "The Crazed Axe",
              value: "The Crazed Axe",
            },
            {
              text: "The Crazed Gross",
              value: "The Crazed Gross",
            },
            {
              text: "The Crazed Cow",
              value: "The Crazed Cow",
            },
            {
              text: "The Crazed Bird",
              value: "The Crazed Bird",
            },
            {
              text: "The Crazed Fish",
              value: "The Crazed Fish",
            },
            {
              text: "The Crazed Lizard",
              value: "The Crazed Lizard",
            },
            {
              text: "The Crazed Titan",
              value: "The Crazed Titan",
            },
            {
              text: "Teacher! It's Spring!",
              value: "Teacher! It's Spring!",
            },
            {
              text: "Weekend Stage",
              value: "Weekend Stage",
            },
            {
              text: "XP Stage",
              value: "XP Stage",
            },
            {
              text: "Love is Sickness",
              value: "Love is Sickness",
            },
            {
              text: "The Forbidden Bride",
              value: "The Forbidden Bride",
            },
            {
              text: "Never Summer!",
              value: "Never Summer!",
            },
            {
              text: "Ghostly Houseguests",
              value: "Ghostly Houseguests",
            },
            {
              text: "Monthly Event All-Stars Special Celebration!",
              value: "Monthly Event All-Stars Special Celebration!",
            },
            {
              text: "Monthly Event All-Stars Ultra Celebration!",
              value: "Monthly Event All-Stars Ultra Celebration!",
            },
            {
              text: "Monthly Event All-Stars Miracle Celebration!",
              value: "Monthly Event All-Stars Miracle Celebration!",
            },
            {
              text: "Old Guys About Town",
              value: "Old Guys About Town",
            },
            {
              text: "Korean Special Stage",
              value: "Korean Special Stage",
            },
            {
              text: "Autumn = Sports Day!",
              value: "Autumn = Sports Day!",
            },
            {
              text: "Wrath of Heaven",
              value: "Wrath of Heaven",
            },
            {
              text: "Happy Birthday! No. 1",
              value: "Happy Birthday! No. 1",
            },
            {
              text: "Happy Birthday! No. 2",
              value: "Happy Birthday! No. 2",
            },
            {
              text: "Happy Birthday! No. 3",
              value: "Happy Birthday! No. 3",
            },
            {
              text: "Sweet Irony",
              value: "Sweet Irony",
            },
            {
              text: "Happy 2015!",
              value: "Happy 2015!",
            },
            {
              text: "Actress Awakens!",
              value: "Actress Awakens!",
            },
            {
              text: "Kung-Fu Awakens!",
              value: "Kung-Fu Awakens!",
            },
            {
              text: "Mr. Awakens!",
              value: "Mr. Awakens!",
            },
            {
              text: "Bondage Awakens!",
              value: "Bondage Awakens!",
            },
            {
              text: "The Dom Awakens!",
              value: "The Dom Awakens!",
            },
            {
              text: "Box Cats Awaken!",
              value: "Box Cats Awaken!",
            },
            {
              text: "Panties Awakens!",
              value: "Panties Awakens!",
            },
            {
              text: "Tricycle Awakens!",
              value: "Tricycle Awakens!",
            },
            {
              text: "Ninja Awakens!",
              value: "Ninja Awakens!",
            },
            {
              text: "Zombie Awakens!",
              value: "Zombie Awakens!",
            },
            {
              text: "Samurai Awakens!",
              value: "Samurai Awakens!",
            },
            {
              text: "Sumo Awakens!",
              value: "Sumo Awakens!",
            },
            {
              text: "Boogie Awakens!",
              value: "Boogie Awakens!",
            },
            {
              text: "Skirt Awakens!",
              value: "Skirt Awakens!",
            },
            {
              text: "XP Megablitz!",
              value: "XP Megablitz!",
            },
            {
              text: "Sweetest Sorrow",
              value: "Sweetest Sorrow",
            },
            {
              text: "Dark Descent",
              value: "Dark Descent",
            },
            {
              text: "Dark Descent II",
              value: "Dark Descent II",
            },
            {
              text: "Dark Descent III",
              value: "Dark Descent III",
            },
            {
              text: "Dark Descent ∞",
              value: "Dark Descent ∞",
            },
            {
              text: "The Battle Cats POP!",
              value: "The Battle Cats POP!",
            },
            {
              text: "Dimension of Despair",
              value: "Dimension of Despair",
            },
            {
              text: "小籠包★Q彈來襲",
              value: "小籠包★Q彈來襲",
            },
            {
              text: "20 Mil Downloads Special Gift!",
              value: "20 Mil Downloads Special Gift!",
            },
            {
              text: "Deadly Carnival",
              value: "Deadly Carnival",
            },
            {
              text: "Monthly Event All-Stars Wonderful Celebration!",
              value: "Monthly Event All-Stars Wonderful Celebration!",
            },
            {
              text: "Minced Meet-Up",
              value: "Minced Meet-Up",
            },
            {
              text: "All Hallows Road",
              value: "All Hallows Road",
            },
            {
              text: "Mon. Blitz Stage",
              value: "Mon. Blitz Stage",
            },
            {
              text: "Tues. Blitz Stage",
              value: "Tues. Blitz Stage",
            },
            {
              text: "Weds. Blitz Stage",
              value: "Weds. Blitz Stage",
            },
            {
              text: "Thurs. Blitz Stage",
              value: "Thurs. Blitz Stage",
            },
            {
              text: "Fri. Blitz Stage",
              value: "Fri. Blitz Stage",
            },
            {
              text: "Facing Danger",
              value: "Facing Danger",
            },
            {
              text: "Event All-Stars Excellent Celebration!",
              value: "Event All-Stars Excellent Celebration!",
            },
            {
              text: "Birthday Present!",
              value: "Birthday Present!",
            },
            {
              text: "Jolly St. Nick",
              value: "Jolly St. Nick",
            },
            {
              text: "Auld Lang Syne!",
              value: "Auld Lang Syne!",
            },
            {
              text: "Adult Cat Awakes!",
              value: "Adult Cat Awakes!",
            },
            {
              text: "Evil Cat Awakes!",
              value: "Evil Cat Awakes!",
            },
            {
              text: "Doll Cats Awake!",
              value: "Doll Cats Awake!",
            },
            {
              text: "Maiden Awakes!",
              value: "Maiden Awakes!",
            },
            {
              text: "Koi Awakens!",
              value: "Koi Awakens!",
            },
            {
              text: "Bride Awakens!",
              value: "Bride Awakens!",
            },
            {
              text: "Vacation Awakens!",
              value: "Vacation Awakens!",
            },
            {
              text: "Vengeance Awakes!",
              value: "Vengeance Awakes!",
            },
            {
              text: "Kung-Fu X Awakes!",
              value: "Kung-Fu X Awakes!",
            },
            {
              text: "Sports Day Awakens!",
              value: "Sports Day Awakens!",
            },
            {
              text: "Salaryman Awakes!",
              value: "Salaryman Awakes!",
            },
            {
              text: "Reindeer Fish Awakens!",
              value: "Reindeer Fish Awakens!",
            },
            {
              text: "Clionel Ascendant",
              value: "Clionel Ascendant",
            },
            {
              text: "Red Sky at Morning",
              value: "Red Sky at Morning",
            },
            {
              text: "Growing Green",
              value: "Growing Green",
            },
            {
              text: "Growing Purple",
              value: "Growing Purple",
            },
            {
              text: "Growing Red",
              value: "Growing Red",
            },
            {
              text: "Growing Blue",
              value: "Growing Blue",
            },
            {
              text: "Growing Yellow",
              value: "Growing Yellow",
            },
            {
              text: "Cat Maniac",
              value: "Cat Maniac",
            },
            {
              text: "Tank Maniac",
              value: "Tank Maniac",
            },
            {
              text: "Axe Maniac",
              value: "Axe Maniac",
            },
            {
              text: "Gross Maniac",
              value: "Gross Maniac",
            },
            {
              text: "Cow Maniac",
              value: "Cow Maniac",
            },
            {
              text: "Bird Maniac",
              value: "Bird Maniac",
            },
            {
              text: "Fish Maniac",
              value: "Fish Maniac",
            },
            {
              text: "Lizard Maniac",
              value: "Lizard Maniac",
            },
            {
              text: "Titan Maniac",
              value: "Titan Maniac",
            },
            {
              text: "Bad to Worse",
              value: "Bad to Worse",
            },
            {
              text: "Day of Judgement",
              value: "Day of Judgement",
            },
            {
              text: "協賛BitSummit記念！",
              value: "協賛BitSummit記念！",
            },
            {
              text: "Techneurosis",
              value: "Techneurosis",
            },
            {
              text: "Summer Diary",
              value: "Summer Diary",
            },
            {
              text: "Mystery Package",
              value: "Mystery Package",
            },
            {
              text: "River Styx",
              value: "River Styx",
            },
            {
              text: "Catfruit Buffet",
              value: "Catfruit Buffet",
            },
            {
              text: "Queen's Coronation",
              value: "Queen's Coronation",
            },
            {
              text: "Deadly Carnival II",
              value: "Deadly Carnival II",
            },
            {
              text: "A Cultured Festival",
              value: "A Cultured Festival",
            },
            {
              text: "The Rolling Dead",
              value: "The Rolling Dead",
            },
            {
              text: "XP Colosseum",
              value: "XP Colosseum",
            },
            {
              text: "Cats in the Snow",
              value: "Cats in the Snow",
            },
            {
              text: "You Nears!",
              value: "You Nears!",
            },
            {
              text: "Day of the Cat",
              value: "Day of the Cat",
            },
            {
              text: "Dead on Debut",
              value: "Dead on Debut",
            },
            {
              text: "Spring Sprang Sprung",
              value: "Spring Sprang Sprung",
            },
            {
              text: "Li'l Cat Awakens!",
              value: "Li'l Cat Awakens!",
            },
            {
              text: "Li'l Tank Awakens!",
              value: "Li'l Tank Awakens!",
            },
            {
              text: "Li'l Axe Awakens!",
              value: "Li'l Axe Awakens!",
            },
            {
              text: "Li'l Gross Awakens!",
              value: "Li'l Gross Awakens!",
            },
            {
              text: "Li'l Cow Awakens!",
              value: "Li'l Cow Awakens!",
            },
            {
              text: "Li'l Bird Awakens!",
              value: "Li'l Bird Awakens!",
            },
            {
              text: "Li'l Fish Awakens!",
              value: "Li'l Fish Awakens!",
            },
            {
              text: "Li'l Lizard Awakens!",
              value: "Li'l Lizard Awakens!",
            },
            {
              text: "Li'l Titan Awakens!",
              value: "Li'l Titan Awakens!",
            },
            {
              text: "For the Fans",
              value: "For the Fans",
            },
            {
              text: "The Midas Touch",
              value: "The Midas Touch",
            },
            {
              text: "Sliming to Victory (Old)",
              value: "Sliming to Victory (Old)",
            },
            {
              text: "Cat Kart Awakens!",
              value: "Cat Kart Awakens!",
            },
            {
              text: "開眼のネコンドー襲来！",
              value: "開眼のネコンドー襲来！",
            },
            {
              text: "30M Celebration Gifts Galore!",
              value: "30M Celebration Gifts Galore!",
            },
            {
              text: "Event All-Stars Grand Jubilee!",
              value: "Event All-Stars Grand Jubilee!",
            },
            {
              text: "Watch & Earn",
              value: "Watch & Earn",
            },
            {
              text: "Flower Cat Awakens!",
              value: "Flower Cat Awakens!",
            },
            {
              text: "Summer Lesson",
              value: "Summer Lesson",
            },
            {
              text: "Cavern of Comets",
              value: "Cavern of Comets",
            },
            {
              text: "Island of Ash",
              value: "Island of Ash",
            },
            {
              text: "Strait of Wings",
              value: "Strait of Wings",
            },
            {
              text: "Catburger Awakens!",
              value: "Catburger Awakens!",
            },
            {
              text: "Silver Week",
              value: "Silver Week",
            },
            {
              text: "Merciless XP!",
              value: "Merciless XP!",
            },
            {
              text: "The 2nd Dimension",
              value: "The 2nd Dimension",
            },
            {
              text: "King Wahwah's Revenge",
              value: "King Wahwah's Revenge",
            },
            {
              text: "Go Go Graduates!",
              value: "Go Go Graduates!",
            },
            {
              text: "Crazed Moneko",
              value: "Crazed Moneko",
            },
            {
              text: "Growing Strange",
              value: "Growing Strange",
            },
            {
              text: "Sliming to Victory",
              value: "Sliming to Victory",
            },
            {
              text: "Forbidden Bride Pt II",
              value: "Forbidden Bride Pt II",
            },
            {
              text: "Never Not Summer!",
              value: "Never Not Summer!",
            },
            {
              text: "Ghostly Strangers",
              value: "Ghostly Strangers",
            },
            {
              text: "Old Guys in the City",
              value: "Old Guys in the City",
            },
            {
              text: "Crimson Vengeance",
              value: "Crimson Vengeance",
            },
            {
              text: "Sports Night",
              value: "Sports Night",
            },
            {
              text: "Worker's Revolution",
              value: "Worker's Revolution",
            },
            {
              text: "NEO Darkness Heaven",
              value: "NEO Darkness Heaven",
            },
            {
              text: "Cybear's Vengeance",
              value: "Cybear's Vengeance",
            },
            {
              text: "Christmas in Space",
              value: "Christmas in Space",
            },
            {
              text: "Peerless Too",
              value: "Peerless Too",
            },
            {
              text: "Deeply Dreaming",
              value: "Deeply Dreaming",
            },
            {
              text: "Seeing Red",
              value: "Seeing Red",
            },
            {
              text: "Seeing Red II",
              value: "Seeing Red II",
            },
            {
              text: "Seeing Red III",
              value: "Seeing Red III",
            },
            {
              text: "Seeing Red ∞",
              value: "Seeing Red ∞",
            },
            {
              text: "Event All-Stars Super Present DX",
              value: "Event All-Stars Super Present DX",
            },
            {
              text: "B-Day Gifts",
              value: "B-Day Gifts",
            },
            {
              text: "Another New Year",
              value: "Another New Year",
            },
            {
              text: "Wrath of the Divine",
              value: "Wrath of the Divine",
            },
            {
              text: "Ritual Confusion",
              value: "Ritual Confusion",
            },
            {
              text: "Bitter Irony",
              value: "Bitter Irony",
            },
            {
              text: "Typhoon Nemo",
              value: "Typhoon Nemo",
            },
            {
              text: "Deadly Carnival III",
              value: "Deadly Carnival III",
            },
            {
              text: "40M Celebration Gifts Galore!",
              value: "40M Celebration Gifts Galore!",
            },
            {
              text: "Bears Be Back",
              value: "Bears Be Back",
            },
            {
              text: "Dimension of Delirium",
              value: "Dimension of Delirium",
            },
            {
              text: "Spring for Sensei",
              value: "Spring for Sensei",
            },
            {
              text: "Red Sky at Night",
              value: "Red Sky at Night",
            },
            {
              text: "Clionel Dominant",
              value: "Clionel Dominant",
            },
            {
              text: "Lovesick Again",
              value: "Lovesick Again",
            },
            {
              text: "The Dead Keep Rolling",
              value: "The Dead Keep Rolling",
            },
            {
              text: "River Acheron",
              value: "River Acheron",
            },
            {
              text: "にゃんこグミ大戦争",
              value: "にゃんこグミ大戦争",
            },
            {
              text: "Queen's Condemnation",
              value: "Queen's Condemnation",
            },
            {
              text: "The 3rd Dimension",
              value: "The 3rd Dimension",
            },
            {
              text: "Dead by Encore",
              value: "Dead by Encore",
            },
            {
              text: "The Battle Cats Together!",
              value: "The Battle Cats Together!",
            },
            {
              text: "King Wahwah's Return",
              value: "King Wahwah's Return",
            },
            {
              text: "Clan of the Maniacs",
              value: "Clan of the Maniacs",
            },
            {
              text: "Meow Meow Day",
              value: "Meow Meow Day",
            },
            {
              text: "Duel on the Prarie",
              value: "Duel on the Prarie",
            },
            {
              text: "Duel at Sunset",
              value: "Duel at Sunset",
            },
            {
              text: "Duel Under the Stars",
              value: "Duel Under the Stars",
            },
            {
              text: "Duel on the Dunes",
              value: "Duel on the Dunes",
            },
            {
              text: "A Deeper Dream",
              value: "A Deeper Dream",
            },
            {
              text: "Blue Impact",
              value: "Blue Impact",
            },
            {
              text: "Courts of Torment",
              value: "Courts of Torment",
            },
            {
              text: "謎の宅配便",
              value: "謎の宅配便",
            },
            {
              text: "Papuu's Paradise",
              value: "Papuu's Paradise",
            },
            {
              text: "The Old Queen",
              value: "The Old Queen",
            },
            {
              text: "Growing Epic",
              value: "Growing Epic",
            },
            {
              text: "Most Defeated 2019",
              value: "Most Defeated 2019",
            },
            {
              text: "Lunar New Year",
              value: "Lunar New Year",
            },
            {
              text: "Bottom of the Swamp",
              value: "Bottom of the Swamp",
            },
            {
              text: "Duel at the Lava Fields",
              value: "Duel at the Lava Fields",
            },
            {
              text: "50M Celebration Gifts Galore!",
              value: "50M Celebration Gifts Galore!",
            },
            {
              text: "Wanwan's Glory",
              value: "Wanwan's Glory",
            },
            {
              text: "Z-Onel Rises!",
              value: "Z-Onel Rises!",
            },
            {
              text: "First Errand",
              value: "First Errand",
            },
            {
              text: "Isle of the Map Lord",
              value: "Isle of the Map Lord",
            },
            {
              text: "Total War: Spring Special",
              value: "Total War: Spring Special",
            },
            {
              text: "Total War: Summer Special",
              value: "Total War: Summer Special",
            },
            {
              text: "Total War: Fall Special",
              value: "Total War: Fall Special",
            },
            {
              text: "Total War: Winter Special",
              value: "Total War: Winter Special",
            },
            {
              text: "Tag Arena: Rookie",
              value: "Tag Arena: Rookie",
            },
            {
              text: "Tag Arena: Beginner",
              value: "Tag Arena: Beginner",
            },
            {
              text: "Tag Arena: Adept",
              value: "Tag Arena: Adept",
            },
            {
              text: "Tag Arena: Pro",
              value: "Tag Arena: Pro",
            },
            {
              text: "Tag Arena: Expert",
              value: "Tag Arena: Expert",
            },
            {
              text: "Top of the Bog",
              value: "Top of the Bog",
            },
            {
              text: "Most Appearances 2020",
              value: "Most Appearances 2020",
            },
            {
              text: "Prelude to Ruin",
              value: "Prelude to Ruin",
            },
            {
              text: "Typhoon Nihil",
              value: "Typhoon Nihil",
            },
            {
              text: "Duel Under the Sea",
              value: "Duel Under the Sea",
            },
            {
              text: "ネコウエハース降臨",
              value: "ネコウエハース降臨",
            },
            {
              text: "The Proving Grounds",
              value: "The Proving Grounds",
            },
            {
              text: "The Angel & The Demon",
              value: "The Angel & The Demon",
            },
            {
              text: "The Queen & The Dead",
              value: "The Queen & The Dead",
            },
            {
              text: "The King & The Maiden",
              value: "The King & The Maiden",
            },
            {
              text: "60M Celebration Gifts Galore!",
              value: "60M Celebration Gifts Galore!",
            },
            {
              text: "Arcane Confluence",
              value: "Arcane Confluence",
            },
            {
              text: "Servant of Darkness",
              value: "Servant of Darkness",
            },
            {
              text: "Wicked Cat",
              value: "Wicked Cat",
            },
            {
              text: "Wicked Tank",
              value: "Wicked Tank",
            },
            {
              text: "The Great Diablo",
              value: "The Great Diablo",
            },
            {
              text: "Hotblooded Ball-Rolling",
              value: "Hotblooded Ball-Rolling",
            },
            {
              text: "Hotblooded Challenge Course",
              value: "Hotblooded Challenge Course",
            },
            {
              text: "Hotblooded Three-Leg Race ①",
              value: "Hotblooded Three-Leg Race ①",
            },
            {
              text: "Hotblooded Three-Leg Race ②",
              value: "Hotblooded Three-Leg Race ②",
            },
            {
              text: "Hotblooded Three-Leg Race ③",
              value: "Hotblooded Three-Leg Race ③",
            },
            {
              text: "Demon's Park",
              value: "Demon's Park",
            },
            {
              text: "Wicked Axe",
              value: "Wicked Axe",
            },
            {
              text: "세뱃돈 습격!",
              value: "세뱃돈 습격!",
            },
            {
              text: "Unleashing the Cats",
              value: "Unleashing the Cats",
            },
            {
              text: "Empress' Report 1",
              value: "Empress' Report 1",
            },
            {
              text: "Empress' Report 2",
              value: "Empress' Report 2",
            },
            {
              text: "Empress' Report 3",
              value: "Empress' Report 3",
            },
            {
              text: "Temptation's Symphony",
              value: "Temptation's Symphony",
            },
            {
              text: "Rashomon",
              value: "Rashomon",
            },
            {
              text: "Growing Evil",
              value: "Growing Evil",
            },
            {
              text: "Empress' Report 4",
              value: "Empress' Report 4",
            },
            {
              text: "Empress' Report 5",
              value: "Empress' Report 5",
            },
            {
              text: "Empress' Excavation 1",
              value: "Empress' Excavation 1",
            },
            {
              text: "Empress' Excavation 2",
              value: "Empress' Excavation 2",
            },
            {
              text: "Empress' Excavation 3",
              value: "Empress' Excavation 3",
            },
            {
              text: "Empress' Excavation 4 (placeholder)",
              value: "Empress' Excavation 4 (placeholder)",
            },
            {
              text: "Empress' Excavation 5 (placeholder)",
              value: "Empress' Excavation 5 (placeholder)",
            },
            {
              text: "Q1.箱の中身クイズ",
              value: "Q1.箱の中身クイズ",
            },
            {
              text: "Q5.時の運クイズ",
              value: "Q5.時の運クイズ",
            },
            {
              text: "バースデープレゼント！",
              value: "バースデープレゼント！",
            },
            {
              text: "Top 5 Most Seen Enemies, 2021!",
              value: "Top 5 Most Seen Enemies, 2021!",
            },
            {
              text: "New Year's Bling",
              value: "New Year's Bling",
            },
            {
              text: "Cover of Darkness",
              value: "Cover of Darkness",
            },
            {
              text: "春節ハッピープレゼント！",
              value: "春節ハッピープレゼント！",
            },
            {
              text: "The March of Flames",
              value: "The March of Flames",
            },
            {
              text: "From Your Junior",
              value: "From Your Junior",
            },
            {
              text: "From Your Senpai",
              value: "From Your Senpai",
            },
            {
              text: "From A Childhood Friend",
              value: "From A Childhood Friend",
            },
            {
              text: "中秋節ハッピープレゼント！",
              value: "中秋節ハッピープレゼント！",
            },
            {
              text: "RS_294",
              value: "RS_294",
            },
            {
              text: "RS_295",
              value: "RS_295",
            },
            {
              text: "Courts of Agony",
              value: "Courts of Agony",
            },
            {
              text: "War on Valentines",
              value: "War on Valentines",
            },
            {
              text: "Season 2: Heartbeat Festival",
              value: "Season 2: Heartbeat Festival",
            },
            {
              text: "Season 3: Field Trip",
              value: "Season 3: Field Trip",
            },
            {
              text: "Weekend: Confession",
              value: "Weekend: Confession",
            },
            {
              text: "Season 4: Graduation Day",
              value: "Season 4: Graduation Day",
            },
            {
              text: "70M Celebration Gifts Galore!",
              value: "70M Celebration Gifts Galore!",
            },
            {
              text: "The Dead & The Bloated",
              value: "The Dead & The Bloated",
            },
            {
              text: "The Queen & The Maiden",
              value: "The Queen & The Maiden",
            },
            {
              text: "The King & The Angel",
              value: "The King & The Angel",
            },
            {
              text: "#02 ??? the 13th",
              value: "#02 ??? the 13th",
            },
            {
              text: "#03 Yowling Village",
              value: "#03 Yowling Village",
            },
            {
              text: "決闘チャレンジ",
              value: "決闘チャレンジ",
            },
            {
              text: "タッグ闘技チャレンジ",
              value: "タッグ闘技チャレンジ",
            },
            {
              text: "Affliction in the Forest",
              value: "Affliction in the Forest",
            },
            {
              text: "Oddity in the Desert",
              value: "Oddity in the Desert",
            },
            {
              text: "Peril in the Volcano",
              value: "Peril in the Volcano",
            },
            {
              text: "Bug Sumo Preliminaries",
              value: "Bug Sumo Preliminaries",
            },
            {
              text: "Bug Sumo Quarterfinals",
              value: "Bug Sumo Quarterfinals",
            },
            {
              text: "Bug Sumo Semifinals",
              value: "Bug Sumo Semifinals",
            },
            {
              text: "Bug Sumo Finals",
              value: "Bug Sumo Finals",
            },
            {
              text: "XP Bonanza!",
              value: "XP Bonanza!",
            },
            {
              text: "#01 Sugar Struggle",
              value: "#01 Sugar Struggle",
            },
            {
              text: "#03 Mischevous Schemes",
              value: "#03 Mischevous Schemes",
            },
            {
              text: "第2部 敵軍団行進",
              value: "第2部 敵軍団行進",
            },
            {
              text: "第5部 名曲パレード",
              value: "第5部 名曲パレード",
            },
            {
              text: "バースデープレゼント!",
              value: "バースデープレゼント!",
            },
            {
              text: "Night 1: Santa Claws at Work",
              value: "Night 1: Santa Claws at Work",
            },
            {
              text: "進化の虹獣石",
              value: "進化の虹獣石",
            },
            {
              text: "2022年最多出演敵ベスト５！",
              value: "2022年最多出演敵ベスト５！",
            },
          ],
        },
        {
          category: "Story Mode",
          chapters: [
            {
              text: "EoC 1",
              value: "EoC 1",
            },
            {
              text: "EoC 2",
              value: "EoC 2",
            },
            {
              text: "EoC 3",
              value: "EoC 3",
            },
            {
              text: "ItF 1",
              value: "ItF 1",
            },
            {
              text: "ItF 2",
              value: "ItF 2",
            },
            {
              text: "ItF 3",
              value: "ItF 3",
            },
            {
              text: "CotC 1",
              value: "CotC 1",
            },
            {
              text: "CotC 2",
              value: "CotC 2",
            },
            {
              text: "CotC 3",
              value: "CotC 3",
            },
          ],
        },
        {
          category: "Collab",
          chapters: [
            {
              text: "ふるさと自衛隊",
              value: "ふるさと自衛隊",
            },
            {
              text: "魅惑のプリンセス",
              value: "魅惑のプリンセス",
            },
            {
              text: "ケリ姫ステージ",
              value: "ケリ姫ステージ",
            },
            {
              text: "To the Future",
              value: "To the Future",
            },
            {
              text: "拡散性ミリオンアーサー",
              value: "拡散性ミリオンアーサー",
            },
            {
              text: "ドラゴンポーカー",
              value: "ドラゴンポーカー",
            },
            {
              text: "Lasvoss Strikes?!",
              value: "Lasvoss Strikes?!",
            },
            {
              text: "Merc Storia: Inferno",
              value: "Merc Storia: Inferno",
            },
            {
              text: "Merc Storia: Showdown",
              value: "Merc Storia: Showdown",
            },
            {
              text: "ドラゴンリーグ",
              value: "ドラゴンリーグ",
            },
            {
              text: "超激突！氣志團！！",
              value: "超激突！氣志團！！",
            },
            {
              text: "Survive! Mola Mola!",
              value: "Survive! Mola Mola!",
            },
            {
              text: "Droid Awakes!",
              value: "Droid Awakes!",
            },
            {
              text: "消滅都市 ～第１章～",
              value: "消滅都市 ～第１章～",
            },
            {
              text: "消滅都市 ～第２章～",
              value: "消滅都市 ～第２章～",
            },
            {
              text: "消滅都市 ～第３章～",
              value: "消滅都市 ～第３章～",
            },
            {
              text: "極道大戦争",
              value: "極道大戦争",
            },
            {
              text: "逆襲のメルクストーリア",
              value: "逆襲のメルクストーリア",
            },
            {
              text: "Healer Awakens!",
              value: "Healer Awakens!",
            },
            {
              text: "モンハン大狩猟クエスト",
              value: "モンハン大狩猟クエスト",
            },
            {
              text: "【緊急】モンハン大狩猟クエスト",
              value: "【緊急】モンハン大狩猟クエスト",
            },
            {
              text: "Matal Slug Defense",
              value: "Matal Slug Defense",
            },
            {
              text: "Super Matal Slug Defense",
              value: "Super Matal Slug Defense",
            },
            {
              text: "神略！ゆるドラシル",
              value: "神略！ゆるドラシル",
            },
            {
              text: "城とドラゴン",
              value: "城とドラゴン",
            },
            {
              text: "開眼の城とドラゴン",
              value: "開眼の城とドラゴン",
            },
            {
              text: "難攻不落の城とドラゴン",
              value: "難攻不落の城とドラゴン",
            },
            {
              text: "まもるよネコさん",
              value: "まもるよネコさん",
            },
            {
              text: "Takuya & Yuki Awaken",
              value: "Takuya & Yuki Awaken",
            },
            {
              text: "A Fungal Challenge",
              value: "A Fungal Challenge",
            },
            {
              text: "ふてたネコあらわる",
              value: "ふてたネコあらわる",
            },
            {
              text: "Puella Magi Madoka Magica",
              value: "Puella Magi Madoka Magica",
            },
            {
              text: "Witch's Labyrinth",
              value: "Witch's Labyrinth",
            },
            {
              text: "Walpurgisnacht",
              value: "Walpurgisnacht",
            },
            {
              text: "突撃！キャットバスターズ",
              value: "突撃！キャットバスターズ",
            },
            {
              text: "Cabaret Cat Awakens!",
              value: "Cabaret Cat Awakens!",
            },
            {
              text: "PIKOTARO",
              value: "PIKOTARO",
            },
            {
              text: "追逐夢想男偶像",
              value: "追逐夢想男偶像",
            },
            {
              text: "ナゾのウサギ登場!?",
              value: "ナゾのウサギ登場!?",
            },
            {
              text: "Gates of ALICE",
              value: "Gates of ALICE",
            },
            {
              text: "Moonlit City",
              value: "Moonlit City",
            },
            {
              text: "開眼のケリ姫襲来！",
              value: "開眼のケリ姫襲来！",
            },
            {
              text: "開眼の眠れるケリの美女襲来！",
              value: "開眼の眠れるケリの美女襲来！",
            },
            {
              text: "The Lost World",
              value: "The Lost World",
            },
            {
              text: "Merc Awakens!",
              value: "Merc Awakens!",
            },
            {
              text: "Titi Awakens!",
              value: "Titi Awakens!",
            },
            {
              text: "神秘のメルクストーリア",
              value: "神秘のメルクストーリア",
            },
            {
              text: "ぐでぐでしてます",
              value: "ぐでぐでしてます",
            },
            {
              text: "どうせ食べられるだけだし",
              value: "どうせ食べられるだけだし",
            },
            {
              text: "貓奴大王",
              value: "貓奴大王",
            },
            {
              text: "The Holy Grail War",
              value: "The Holy Grail War",
            },
            {
              text: "Holy War: Saber",
              value: "Holy War: Saber",
            },
            {
              text: "Holy War: Lancer",
              value: "Holy War: Lancer",
            },
            {
              text: "Holy War: Archer",
              value: "Holy War: Archer",
            },
            {
              text: "Holy War: Rider",
              value: "Holy War: Rider",
            },
            {
              text: "Holy War: Gilgamesh",
              value: "Holy War: Gilgamesh",
            },
            {
              text: "Sophomore Summer",
              value: "Sophomore Summer",
            },
            {
              text: "Prof. Wild's Challenge",
              value: "Prof. Wild's Challenge",
            },
            {
              text: "Date Chance: Karin",
              value: "Date Chance: Karin",
            },
            {
              text: "Date Chance: Misaki",
              value: "Date Chance: Misaki",
            },
            {
              text: "Date Chance: Sairi",
              value: "Date Chance: Sairi",
            },
            {
              text: "Date Chance: Ren",
              value: "Date Chance: Ren",
            },
            {
              text: "Mentori's Masterplan",
              value: "Mentori's Masterplan",
            },
            {
              text: "Evangelion Activates!",
              value: "Evangelion Activates!",
            },
            {
              text: "Decisive Battle!",
              value: "Decisive Battle!",
            },
            {
              text: "The 9th Angel Strikes!",
              value: "The 9th Angel Strikes!",
            },
            {
              text: "The 10th Angel Strikes!",
              value: "The 10th Angel Strikes!",
            },
            {
              text: "Poko Forest Friends!",
              value: "Poko Forest Friends!",
            },
            {
              text: "Trio from the Woods",
              value: "Trio from the Woods",
            },
            {
              text: "太秦萌の通学",
              value: "太秦萌の通学",
            },
            {
              text: "松賀咲の通学",
              value: "松賀咲の通学",
            },
            {
              text: "小野ミサの通学",
              value: "小野ミサの通学",
            },
            {
              text: "地下鉄に乗るっ",
              value: "地下鉄に乗るっ",
            },
            {
              text: "City of Souls",
              value: "City of Souls",
            },
            {
              text: "ぐでぐでしてて忙しい",
              value: "ぐでぐでしてて忙しい",
            },
            {
              text: "開眼のぐでたまにゃんこ襲来！",
              value: "開眼のぐでたまにゃんこ襲来！",
            },
            {
              text: "城ドラ VS 城ドラ",
              value: "城ドラ VS 城ドラ",
            },
            {
              text: "Groove Like A Bear",
              value: "Groove Like A Bear",
            },
            {
              text: "ケットバス王国の教え",
              value: "ケットバス王国の教え",
            },
            {
              text: "A Fake Mitakihara",
              value: "A Fake Mitakihara",
            },
            {
              text: "Queen Rampant",
              value: "Queen Rampant",
            },
            {
              text: "ヒカキン降臨",
              value: "ヒカキン降臨",
            },
            {
              text: "開眼のヒカキン襲来！",
              value: "開眼のヒカキン襲来！",
            },
            {
              text: "Merc Storia: Attack",
              value: "Merc Storia: Attack",
            },
            {
              text: "Merc Storia: Mystery",
              value: "Merc Storia: Mystery",
            },
            {
              text: "Holy War: Saber Alter",
              value: "Holy War: Saber Alter",
            },
            {
              text: "300 Million Dead Molas",
              value: "300 Million Dead Molas",
            },
            {
              text: "開眼三原慧悟來襲！",
              value: "開眼三原慧悟來襲！",
            },
            {
              text: "和麻吉貓一起寶島趴趴走！",
              value: "和麻吉貓一起寶島趴趴走！",
            },
            {
              text: "Spirit War",
              value: "Spirit War",
            },
            {
              text: "Bikkuriman Choco",
              value: "Bikkuriman Choco",
            },
            {
              text: "Devilish Illusion",
              value: "Devilish Illusion",
            },
            {
              text: "Yamato Awakens!",
              value: "Yamato Awakens!",
            },
            {
              text: "ゆる～い！ねこ娘襲来！",
              value: "ゆる～い！ねこ娘襲来！",
            },
            {
              text: "ゆる～いゲゲゲの鬼太郎",
              value: "ゆる～いゲゲゲの鬼太郎",
            },
            {
              text: "Annihilated City",
              value: "Annihilated City",
            },
            {
              text: "The World Beyond",
              value: "The World Beyond",
            },
            {
              text: "激闘！スイーツ大戦争",
              value: "激闘！スイーツ大戦争",
            },
            {
              text: "開眼巧克力來襲！",
              value: "開眼巧克力來襲！",
            },
            {
              text: "Unit-13 Strikes!",
              value: "Unit-13 Strikes!",
            },
            {
              text: "高雄捷運 紅線",
              value: "高雄捷運 紅線",
            },
            {
              text: "高雄捷運 橘線",
              value: "高雄捷運 橘線",
            },
            {
              text: "Shakurel Planet",
              value: "Shakurel Planet",
            },
            {
              text: "ドットヒーローズ",
              value: "ドットヒーローズ",
            },
            {
              text: "Street Fighter (Easy)",
              value: "Street Fighter (Easy)",
            },
            {
              text: "Street Fighter (Normal)",
              value: "Street Fighter (Normal)",
            },
            {
              text: "Street Fighter (Hard)",
              value: "Street Fighter (Hard)",
            },
            {
              text: "New Challenger",
              value: "New Challenger",
            },
            {
              text: "７周年★東京スカイツリー",
              value: "７周年★東京スカイツリー",
            },
            {
              text: "Hatsune Miku",
              value: "Hatsune Miku",
            },
            {
              text: "MIKU EXPO",
              value: "MIKU EXPO",
            },
            {
              text: "MIKU CHERRY",
              value: "MIKU CHERRY",
            },
            {
              text: "ハマンボ崎あゆみ 強襲！",
              value: "ハマンボ崎あゆみ 強襲！",
            },
            {
              text: "にゃんこ大泥棒",
              value: "にゃんこ大泥棒",
            },
            {
              text: "U.F.O.襲来！",
              value: "U.F.O.襲来！",
            },
            {
              text: "Hatsune Miku's Birthday!",
              value: "Hatsune Miku's Birthday!",
            },
            {
              text: "SNOW MIKU",
              value: "SNOW MIKU",
            },
            {
              text: "Rumble in the Tendo Dojo",
              value: "Rumble in the Tendo Dojo",
            },
            {
              text: "The Cursed Springs",
              value: "The Cursed Springs",
            },
            {
              text: "Godzilla: Final Assault",
              value: "Godzilla: Final Assault",
            },
            {
              text: "Godzilla vs Cats",
              value: "Godzilla vs Cats",
            },
            {
              text: "Be a Magical Girl",
              value: "Be a Magical Girl",
            },
            {
              text: "Be a Magical Girl II",
              value: "Be a Magical Girl II",
            },
            {
              text: "Witch's Labyrinth: Rose Garden Witch",
              value: "Witch's Labyrinth: Rose Garden Witch",
            },
            {
              text: "Witch's Labyrinth: Dessert Witch",
              value: "Witch's Labyrinth: Dessert Witch",
            },
            {
              text: "Witch's Labyrinth: Box Witch",
              value: "Witch's Labyrinth: Box Witch",
            },
            {
              text: "Nutcracker Witch",
              value: "Nutcracker Witch",
            },
            {
              text: "秋華賞（ＧⅠ）",
              value: "秋華賞（ＧⅠ）",
            },
            {
              text: "菊花賞（ＧⅠ）",
              value: "菊花賞（ＧⅠ）",
            },
            {
              text: "天皇賞（秋）（ＧⅠ）",
              value: "天皇賞（秋）（ＧⅠ）",
            },
            {
              text: "有馬記念（ＧⅠ）",
              value: "有馬記念（ＧⅠ）",
            },
            {
              text: "高雄メトロ レッドライン",
              value: "高雄メトロ レッドライン",
            },
            {
              text: "高雄ライトレール",
              value: "高雄ライトレール",
            },
            {
              text: "協賛BitSummit記念！",
              value: "協賛BitSummit記念！",
            },
            {
              text: "Battle! Tamakoma Second's Leader",
              value: "Battle! Tamakoma Second's Leader",
            },
            {
              text: "Battle! Tamakoma Second's Ace",
              value: "Battle! Tamakoma Second's Ace",
            },
            {
              text: "Vs Training Marmod",
              value: "Vs Training Marmod",
            },
            {
              text: "Street Fighter: VERY HARD",
              value: "Street Fighter: VERY HARD",
            },
          ],
        },
        {
          category: "CotC Outbreaks",
          chapters: [
            {
              text: "CotC Ch.1 Zombie",
              value: "CotC Ch.1 Zombie",
            },
          ],
        },
        {
          category: "Heavenly Tower",
          chapters: [
            {
              text: "Heavenly Tower",
              value: "Heavenly Tower",
            },
            {
              text: "Red Citadel",
              value: "Red Citadel",
            },
            {
              text: "Black Citadel",
              value: "Black Citadel",
            },
            {
              text: "Angel Citadel",
              value: "Angel Citadel",
            },
            {
              text: "Alien Citadel",
              value: "Alien Citadel",
            },
            {
              text: "Zombie Citadel",
              value: "Zombie Citadel",
            },
            {
              text: "Infernal Tower",
              value: "Infernal Tower",
            },
            {
              text: "Traitless Citadel",
              value: "Traitless Citadel",
            },
          ],
        },
        {
          category: "Extra",
          chapters: [
            {
              text: "Growing Green",
              value: "Growing Green",
            },
            {
              text: "Growing Purple",
              value: "Growing Purple",
            },
            {
              text: "Growing Red",
              value: "Growing Red",
            },
            {
              text: "Growing Blue",
              value: "Growing Blue",
            },
            {
              text: "Growing Yellow",
              value: "Growing Yellow",
            },
            {
              text: "Bad to Worse",
              value: "Bad to Worse",
            },
            {
              text: "Day of Judgment",
              value: "Day of Judgment",
            },
            {
              text: "Techneurosis",
              value: "Techneurosis",
            },
            {
              text: "Catfruit Buffet",
              value: "Catfruit Buffet",
            },
            {
              text: "Crazed Moneko",
              value: "Crazed Moneko",
            },
            {
              text: "Growing Strange",
              value: "Growing Strange",
            },
            {
              text: "協賛BitSummit記念！",
              value: "協賛BitSummit記念！",
            },
            {
              text: "Growing Epic",
              value: "Growing Epic",
            },
            {
              text: "Idi Invasion",
              value: "Idi Invasion",
            },
            {
              text: "The Proving Grounds",
              value: "The Proving Grounds",
            },
            {
              text: "The Angel & The Demon",
              value: "The Angel & The Demon",
            },
            {
              text: "The Queen & The Dead",
              value: "The Queen & The Dead",
            },
            {
              text: "The King & The Maiden",
              value: "The King & The Maiden",
            },
            {
              text: "Jagando Invasion",
              value: "Jagando Invasion",
            },
            {
              text: "Baron Seal Strikes",
              value: "Baron Seal Strikes",
            },
            {
              text: "Le'Grim Strikes",
              value: "Le'Grim Strikes",
            },
            {
              text: "Mega Menace",
              value: "Mega Menace",
            },
            {
              text: "Horrorpotamus",
              value: "Horrorpotamus",
            },
            {
              text: "Q5.時の運クイズ",
              value: "Q5.時の運クイズ",
            },
            {
              text: "Divine Archangel Strikes",
              value: "Divine Archangel Strikes",
            },
            {
              text: "Big Peng Z Strikes",
              value: "Big Peng Z Strikes",
            },
            {
              text: "Season 3: Field Trip",
              value: "Season 3: Field Trip",
            },
            {
              text: "The Dead & The Bloated",
              value: "The Dead & The Bloated",
            },
            {
              text: "The Queen & The Maiden",
              value: "The Queen & The Maiden",
            },
            {
              text: "The King & The Angel",
              value: "The King & The Angel",
            },
            {
              text: "RE_056",
              value: "RE_056",
            },
            {
              text: "RE_057",
              value: "RE_057",
            },
          ],
        },
        {
          category: "ItF Outbreaks",
          chapters: [
            {
              text: "ItF Ch.1 Zombie",
              value: "ItF Ch.1 Zombie",
            },
            {
              text: "ItF Ch.2 Zombie",
              value: "ItF Ch.2 Zombie",
            },
            {
              text: "ItF Ch.3 Zombie",
              value: "ItF Ch.3 Zombie",
            },
          ],
        },
        {
          category: "Enigma",
          chapters: [
            {
              text: "Aitum Fields",
              value: "Aitum Fields",
            },
            {
              text: "Vitamin Valley",
              value: "Vitamin Valley",
            },
            {
              text: "Ticket Hunter",
              value: "Ticket Hunter",
            },
            {
              text: "Shack of Spirit",
              value: "Shack of Spirit",
            },
            {
              text: "Cave of Spirit",
              value: "Cave of Spirit",
            },
            {
              text: "Labyrinth of Spirit",
              value: "Labyrinth of Spirit",
            },
            {
              text: "Cymophane Cave",
              value: "Cymophane Cave",
            },
            {
              text: "Vitamin Volcano",
              value: "Vitamin Volcano",
            },
            {
              text: "Ticket Hunter G",
              value: "Ticket Hunter G",
            },
            {
              text: "Red Cradle",
              value: "Red Cradle",
            },
            {
              text: "Red Summit",
              value: "Red Summit",
            },
            {
              text: "Red Frontier",
              value: "Red Frontier",
            },
            {
              text: "Sky Cradle",
              value: "Sky Cradle",
            },
            {
              text: "Sky Summit",
              value: "Sky Summit",
            },
            {
              text: "Sky Frontier",
              value: "Sky Frontier",
            },
            {
              text: "Black Cradle",
              value: "Black Cradle",
            },
            {
              text: "Black Summit",
              value: "Black Summit",
            },
            {
              text: "Black Frontier",
              value: "Black Frontier",
            },
            {
              text: "Holy Cradle",
              value: "Holy Cradle",
            },
            {
              text: "Holy Summit",
              value: "Holy Summit",
            },
            {
              text: "Holy Frontier",
              value: "Holy Frontier",
            },
            {
              text: "Cosmic Cradle",
              value: "Cosmic Cradle",
            },
            {
              text: "Cosmic Summit",
              value: "Cosmic Summit",
            },
            {
              text: "Cosmic Frontier",
              value: "Cosmic Frontier",
            },
            {
              text: "Necro Cradle",
              value: "Necro Cradle",
            },
            {
              text: "Necro Summit",
              value: "Necro Summit",
            },
            {
              text: "Necro Frontier",
              value: "Necro Frontier",
            },
            {
              text: "Steel Cradle",
              value: "Steel Cradle",
            },
            {
              text: "Steel Summit",
              value: "Steel Summit",
            },
            {
              text: "Steel Frontier",
              value: "Steel Frontier",
            },
            {
              text: "Rundown Hideout",
              value: "Rundown Hideout",
            },
            {
              text: "Stylish Hideout",
              value: "Stylish Hideout",
            },
            {
              text: "Perfect Hideout",
              value: "Perfect Hideout",
            },
            {
              text: "浮ける本能の起源",
              value: "浮ける本能の起源",
            },
            {
              text: "浮ける本能の頂",
              value: "浮ける本能の頂",
            },
            {
              text: "浮ける本能の秘境",
              value: "浮ける本能の秘境",
            },
            {
              text: "黒き本能の起源",
              value: "黒き本能の起源",
            },
            {
              text: "黒き本能の頂",
              value: "黒き本能の頂",
            },
            {
              text: "黒き本能の秘境",
              value: "黒き本能の秘境",
            },
            {
              text: "聖なる本能の起源",
              value: "聖なる本能の起源",
            },
            {
              text: "聖なる本能の頂",
              value: "聖なる本能の頂",
            },
            {
              text: "聖なる本能の秘境",
              value: "聖なる本能の秘境",
            },
            {
              text: "朽ちた本能の起源",
              value: "朽ちた本能の起源",
            },
            {
              text: "朽ちた本能の頂",
              value: "朽ちた本能の頂",
            },
            {
              text: "朽ちた本能の秘境",
              value: "朽ちた本能の秘境",
            },
            {
              text: "蒼き本能の起源",
              value: "蒼き本能の起源",
            },
            {
              text: "蒼き本能の頂",
              value: "蒼き本能の頂",
            },
            {
              text: "蒼き本能の秘境",
              value: "蒼き本能の秘境",
            },
            {
              text: "Hunter's Map I",
              value: "Hunter's Map I",
            },
            {
              text: "Hunter's Map II",
              value: "Hunter's Map II",
            },
            {
              text: "Hunter's Map III",
              value: "Hunter's Map III",
            },
          ],
        },
        {
          category: "Catamin Stages",
          chapters: [
            {
              text: "Growing Yellow",
              value: "Growing Yellow",
            },
            {
              text: "Growing Blue",
              value: "Growing Blue",
            },
            {
              text: "Growing Red",
              value: "Growing Red",
            },
            {
              text: "Growing Purple",
              value: "Growing Purple",
            },
            {
              text: "Growing Green",
              value: "Growing Green",
            },
            {
              text: "Facing Danger",
              value: "Facing Danger",
            },
            {
              text: "Siege of Hippoe!",
              value: "Siege of Hippoe!",
            },
            {
              text: "Cat Ticket Chance!",
              value: "Cat Ticket Chance!",
            },
            {
              text: "Merciless XP!",
              value: "Merciless XP!",
            },
            {
              text: "XP Colosseum",
              value: "XP Colosseum",
            },
            {
              text: "XP Megablitz!",
              value: "XP Megablitz!",
            },
            {
              text: "XP Stage",
              value: "XP Stage",
            },
            {
              text: "Clionel Ascendant",
              value: "Clionel Ascendant",
            },
            {
              text: "River Styx",
              value: "River Styx",
            },
            {
              text: "Queen's Coronation",
              value: "Queen's Coronation",
            },
            {
              text: "Dead on Debut",
              value: "Dead on Debut",
            },
            {
              text: "King Wahwah's Revenge",
              value: "King Wahwah's Revenge",
            },
            {
              text: "Deeply Dreaming",
              value: "Deeply Dreaming",
            },
            {
              text: "Crimson Catastrophe",
              value: "Crimson Catastrophe",
            },
            {
              text: "Heaven of Darkness",
              value: "Heaven of Darkness",
            },
            {
              text: "Peerless",
              value: "Peerless",
            },
            {
              text: "Wrath of Heaven",
              value: "Wrath of Heaven",
            },
            {
              text: "Sweet Irony",
              value: "Sweet Irony",
            },
            {
              text: "Dimension of Despair",
              value: "Dimension of Despair",
            },
            {
              text: "The Crazed Cat",
              value: "The Crazed Cat",
            },
            {
              text: "The Crazed Tank",
              value: "The Crazed Tank",
            },
            {
              text: "The Crazed Axe",
              value: "The Crazed Axe",
            },
            {
              text: "The Crazed Gross",
              value: "The Crazed Gross",
            },
            {
              text: "The Crazed Cow",
              value: "The Crazed Cow",
            },
            {
              text: "The Crazed Bird",
              value: "The Crazed Bird",
            },
            {
              text: "The Crazed Fish",
              value: "The Crazed Fish",
            },
            {
              text: "The Crazed Lizard",
              value: "The Crazed Lizard",
            },
            {
              text: "The Crazed Titan",
              value: "The Crazed Titan",
            },
            {
              text: "Blue Impact",
              value: "Blue Impact",
            },
            {
              text: "Crazed Moneko",
              value: "Crazed Moneko",
            },
            {
              text: "Red Sky at Morning",
              value: "Red Sky at Morning",
            },
            {
              text: "The Rolling Dead",
              value: "The Rolling Dead",
            },
            {
              text: "Typhoon Nemo",
              value: "Typhoon Nemo",
            },
            {
              text: "The Great Diablo",
              value: "The Great Diablo",
            },
            {
              text: "Bottom of the Swamp",
              value: "Bottom of the Swamp",
            },
            {
              text: "Cat Maniac",
              value: "Cat Maniac",
            },
            {
              text: "Tank Maniac",
              value: "Tank Maniac",
            },
            {
              text: "Axe Maniac",
              value: "Axe Maniac",
            },
            {
              text: "Gross Maniac",
              value: "Gross Maniac",
            },
            {
              text: "Cow Maniac",
              value: "Cow Maniac",
            },
            {
              text: "Bird Maniac",
              value: "Bird Maniac",
            },
            {
              text: "Fish Maniac",
              value: "Fish Maniac",
            },
            {
              text: "Lizard Maniac",
              value: "Lizard Maniac",
            },
            {
              text: "Titan Maniac",
              value: "Titan Maniac",
            },
            {
              text: "The 2nd Dimension",
              value: "The 2nd Dimension",
            },
          ],
        },
        {
          category: "EoC Outbreaks",
          chapters: [
            {
              text: "EoC Ch.1 Zombie",
              value: "EoC Ch.1 Zombie",
            },
            {
              text: "EoC Ch.2 Zombie",
              value: "EoC Ch.2 Zombie",
            },
            {
              text: "EoC Ch.3 Zombie",
              value: "EoC Ch.3 Zombie",
            },
          ],
        },
        {
          category: "The Aku Realms",
          chapters: [
            {
              text: "The Aku Realms",
              value: "The Aku Realms",
            },
          ],
        },
        {
          category: "Dojo",
          chapters: [
            {
              text: "Hall of Initiates",
              value: "Hall of Initiates",
            },
            {
              text: "RT_001",
              value: "RT_001",
            },
          ],
        },
        {
          category: "Behemoth Culling",
          chapters: [
            {
              text: "Hidden Forest of Gapra",
              value: "Hidden Forest of Gapra",
            },
            {
              text: "Ashvini Desert",
              value: "Ashvini Desert",
            },
            {
              text: "Jinfore Volcano",
              value: "Jinfore Volcano",
            },
          ],
        },
        {
          category: "Baron Stages",
          chapters: [
            {
              text: "Baron Seal Strikes!",
              value: "Baron Seal Strikes!",
            },
            {
              text: "Baron Seal Strikes!!",
              value: "Baron Seal Strikes!!",
            },
            {
              text: "Baron Seal Strikes!!!",
              value: "Baron Seal Strikes!!!",
            },
            {
              text: "Le'Grim Strikes!",
              value: "Le'Grim Strikes!",
            },
            {
              text: "Le'Grim Strikes!!",
              value: "Le'Grim Strikes!!",
            },
            {
              text: "Le'Grim Strikes!!!",
              value: "Le'Grim Strikes!!!",
            },
            {
              text: "Mega Menace!",
              value: "Mega Menace!",
            },
            {
              text: "Mega Menace!!",
              value: "Mega Menace!!",
            },
            {
              text: "Mega Menace!!!",
              value: "Mega Menace!!!",
            },
            {
              text: "Horrorpotamus!",
              value: "Horrorpotamus!",
            },
            {
              text: "Horrorpotamus!!",
              value: "Horrorpotamus!!",
            },
            {
              text: "Horrorpotamus!!!",
              value: "Horrorpotamus!!!",
            },
            {
              text: "A Colossal New Year!",
              value: "A Colossal New Year!",
            },
            {
              text: "A Colossal Valentine's",
              value: "A Colossal Valentine's",
            },
            {
              text: "Suffering Spring!",
              value: "Suffering Spring!",
            },
            {
              text: "June Gauntlet",
              value: "June Gauntlet",
            },
            {
              text: "June Gauntlet II",
              value: "June Gauntlet II",
            },
            {
              text: "July Gauntlet",
              value: "July Gauntlet",
            },
            {
              text: "July Gauntlet II",
              value: "July Gauntlet II",
            },
            {
              text: "Summer Break Cats",
              value: "Summer Break Cats",
            },
            {
              text: "Baron Seal Strikes",
              value: "Baron Seal Strikes",
            },
            {
              text: "August Gauntlet",
              value: "August Gauntlet",
            },
            {
              text: "August Gauntlet II",
              value: "August Gauntlet II",
            },
            {
              text: "September Gauntlet",
              value: "September Gauntlet",
            },
            {
              text: "September Gauntlet II",
              value: "September Gauntlet II",
            },
            {
              text: "October Gauntlet",
              value: "October Gauntlet",
            },
            {
              text: "October Gauntlet II",
              value: "October Gauntlet II",
            },
            {
              text: "Le'Grim Strikes",
              value: "Le'Grim Strikes",
            },
            {
              text: "November Gauntlet",
              value: "November Gauntlet",
            },
            {
              text: "November Gauntlet II",
              value: "November Gauntlet II",
            },
            {
              text: "December Gauntlet",
              value: "December Gauntlet",
            },
            {
              text: "December Gauntlet II",
              value: "December Gauntlet II",
            },
            {
              text: "January Gauntlet",
              value: "January Gauntlet",
            },
            {
              text: "January Gauntlet II",
              value: "January Gauntlet II",
            },
            {
              text: "Mega Menace",
              value: "Mega Menace",
            },
            {
              text: "Horrorpotamus",
              value: "Horrorpotamus",
            },
            {
              text: "Divine Archangel Strikes",
              value: "Divine Archangel Strikes",
            },
            {
              text: "Big Peng Z Strikes",
              value: "Big Peng Z Strikes",
            },
            {
              text: "February Gauntlet",
              value: "February Gauntlet",
            },
            {
              text: "February Gauntlet II",
              value: "February Gauntlet II",
            },
            {
              text: "お祭りにゃんこ ～春節編～",
              value: "お祭りにゃんこ ～春節編～",
            },
            {
              text: "Horde of Cats",
              value: "Horde of Cats",
            },
            {
              text: "March Gauntlet",
              value: "March Gauntlet",
            },
            {
              text: "March Gauntlet II",
              value: "March Gauntlet II",
            },
            {
              text: "Attack of the Lonely Hearts",
              value: "Attack of the Lonely Hearts",
            },
            {
              text: "April Gauntlet",
              value: "April Gauntlet",
            },
            {
              text: "April Gauntlet II",
              value: "April Gauntlet II",
            },
            {
              text: "Season 1: School Days",
              value: "Season 1: School Days",
            },
            {
              text: "Monthly Event All-Stars Grateful Gathering",
              value: "Monthly Event All-Stars Grateful Gathering",
            },
            {
              text: "May Gauntlet",
              value: "May Gauntlet",
            },
            {
              text: "May Gauntlet II",
              value: "May Gauntlet II",
            },
            {
              text: "#01 The Ghost Chapel",
              value: "#01 The Ghost Chapel",
            },
            {
              text: "Duel Stages Challenge",
              value: "Duel Stages Challenge",
            },
            {
              text: "Tag Arena Challenge",
              value: "Tag Arena Challenge",
            },
            {
              text: "Island of Hidden Treasure",
              value: "Island of Hidden Treasure",
            },
            {
              text: "#02 Demons' Night Out",
              value: "#02 Demons' Night Out",
            },
            {
              text: "第1部 10年の軌跡パレード",
              value: "第1部 10年の軌跡パレード",
            },
            {
              text: "Night 2: Christmas Eve Delivery",
              value: "Night 2: Christmas Eve Delivery",
            },
            {
              text: "ことよろにゃ強襲！(ΦωΦ)",
              value: "ことよろにゃ強襲！(ΦωΦ)",
            },
          ],
        },
        {
          category: "Labyrinth",
          chapters: [
            {
              text: "L_000",
              value: "L_000",
            },
          ],
        },
        {
          category: "Stories of Legend",
          chapters: [
            {
              text: "The Legend Begins",
              value: "The Legend Begins",
            },
            {
              text: "Passion Land",
              value: "Passion Land",
            },
            {
              text: "Glucosamine Desert",
              value: "Glucosamine Desert",
            },
            {
              text: "Swimming Cats",
              value: "Swimming Cats",
            },
            {
              text: "Risque Terrain",
              value: "Risque Terrain",
            },
            {
              text: "Western Street",
              value: "Western Street",
            },
            {
              text: "Sea of Tuna",
              value: "Sea of Tuna",
            },
            {
              text: "Bamboo Island",
              value: "Bamboo Island",
            },
            {
              text: "Squishy Cave",
              value: "Squishy Cave",
            },
            {
              text: "Volkanos Volcano",
              value: "Volkanos Volcano",
            },
            {
              text: "Neverending Cat Story",
              value: "Neverending Cat Story",
            },
            {
              text: "Castle of Fish",
              value: "Castle of Fish",
            },
            {
              text: "Sushi Island",
              value: "Sushi Island",
            },
            {
              text: "The Scratching Post",
              value: "The Scratching Post",
            },
            {
              text: "Parthenon",
              value: "Parthenon",
            },
            {
              text: "Low Tide Beach",
              value: "Low Tide Beach",
            },
            {
              text: "Alcatraz",
              value: "Alcatraz",
            },
            {
              text: "Jail Break Tunnel",
              value: "Jail Break Tunnel",
            },
            {
              text: "Capone's Jail",
              value: "Capone's Jail",
            },
            {
              text: "Silk Road",
              value: "Silk Road",
            },
            {
              text: "Stairway to Darkness",
              value: "Stairway to Darkness",
            },
            {
              text: "Prince of Darkness",
              value: "Prince of Darkness",
            },
            {
              text: "Dead End Night",
              value: "Dead End Night",
            },
            {
              text: "Battle Royale",
              value: "Battle Royale",
            },
            {
              text: "Scars of War",
              value: "Scars of War",
            },
            {
              text: "Sea Polluter",
              value: "Sea Polluter",
            },
            {
              text: "Body & Soul",
              value: "Body & Soul",
            },
            {
              text: "Weak & Mildly Acidic",
              value: "Weak & Mildly Acidic",
            },
            {
              text: "Intrepid Cats",
              value: "Intrepid Cats",
            },
            {
              text: "Shadow Cosmopolis",
              value: "Shadow Cosmopolis",
            },
            {
              text: "Galapa-Goth",
              value: "Galapa-Goth",
            },
            {
              text: "Kombu Cape",
              value: "Kombu Cape",
            },
            {
              text: "Axis of Evil",
              value: "Axis of Evil",
            },
            {
              text: "Suburbs of the Dead",
              value: "Suburbs of the Dead",
            },
            {
              text: "Quarantine Isles",
              value: "Quarantine Isles",
            },
            {
              text: "Mouseyland",
              value: "Mouseyland",
            },
            {
              text: "Walk of Fame",
              value: "Walk of Fame",
            },
            {
              text: "Cutpurse Coast",
              value: "Cutpurse Coast",
            },
            {
              text: "Above & Below",
              value: "Above & Below",
            },
            {
              text: "Windless Island",
              value: "Windless Island",
            },
            {
              text: "IT Catacombs",
              value: "IT Catacombs",
            },
            {
              text: "Grotesque Gallery",
              value: "Grotesque Gallery",
            },
            {
              text: "Area 22",
              value: "Area 22",
            },
            {
              text: "Beyond the Savannah",
              value: "Beyond the Savannah",
            },
            {
              text: "Blizzard Boulevard",
              value: "Blizzard Boulevard",
            },
            {
              text: "Singularityville",
              value: "Singularityville",
            },
            {
              text: "Ends of the Earth",
              value: "Ends of the Earth",
            },
            {
              text: "The Legend Ends",
              value: "The Legend Ends",
            },
            {
              text: "Laboratory of Relics",
              value: "Laboratory of Relics",
            },
          ],
        },
        {
          category: "Ranked Dojo",
          chapters: [
            {
              text: "RR_000",
              value: "RR_000",
            },
            {
              text: "RR_001",
              value: "RR_001",
            },
            {
              text: "RR_002",
              value: "RR_002",
            },
            {
              text: "RR_003",
              value: "RR_003",
            },
            {
              text: "RR_004",
              value: "RR_004",
            },
            {
              text: "Arena of Honor",
              value: "Arena of Honor",
            },
            {
              text: "RR_006",
              value: "RR_006",
            },
            {
              text: "RR_007",
              value: "RR_007",
            },
            {
              text: "RR_008",
              value: "RR_008",
            },
            {
              text: "RR_009",
              value: "RR_009",
            },
            {
              text: "RR_010",
              value: "RR_010",
            },
            {
              text: "RR_011",
              value: "RR_011",
            },
            {
              text: "RR_012",
              value: "RR_012",
            },
            {
              text: "RR_013",
              value: "RR_013",
            },
            {
              text: "RR_014",
              value: "RR_014",
            },
            {
              text: "Arena of Power",
              value: "Arena of Power",
            },
            {
              text: "RR_019",
              value: "RR_019",
            },
            {
              text: "Tales of Honor",
              value: "Tales of Honor",
            },
            {
              text: "RR_023",
              value: "RR_023",
            },
            {
              text: "RR_024",
              value: "RR_024",
            },
          ],
        },
        {
          category: "Collab Barons",
          chapters: [
            {
              text: "Messier's Assault",
              value: "Messier's Assault",
            },
            {
              text: "U.F.O.軍団 強襲！",
              value: "U.F.O.軍団 強襲！",
            },
            {
              text: "The Devils Strike!",
              value: "The Devils Strike!",
            },
            {
              text: "The Angels Strike!",
              value: "The Angels Strike!",
            },
            {
              text: "Trials of Merc Storia!",
              value: "Trials of Merc Storia!",
            },
            {
              text: "Electric Diva Strikes!",
              value: "Electric Diva Strikes!",
            },
            {
              text: "Heralds of The End",
              value: "Heralds of The End",
            },
            {
              text: "Test of Might: Ranma 1/2",
              value: "Test of Might: Ranma 1/2",
            },
            {
              text: "Walpurgisnacht",
              value: "Walpurgisnacht",
            },
            {
              text: "めざせＧＩ にゃんこ競馬",
              value: "めざせＧＩ にゃんこ競馬",
            },
            {
              text: "強襲！城とドラゴン",
              value: "強襲！城とドラゴン",
            },
            {
              text: "強襲！らんま1/2",
              value: "強襲！らんま1/2",
            },
            {
              text: "Manbosaki Strikes!",
              value: "Manbosaki Strikes!",
            },
            {
              text: "Gauntlet of Servants",
              value: "Gauntlet of Servants",
            },
          ],
        },
        {
          category: "Challenge Battle",
          chapters: [
            {
              text: "Challenge Battle",
              value: "Challenge Battle",
            },
          ],
        },
        {
          category: "Uncanny Legends",
          chapters: [
            {
              text: "A New Legend",
              value: "A New Legend",
            },
            {
              text: "Here Be Dragons",
              value: "Here Be Dragons",
            },
            {
              text: "The Endless Wood",
              value: "The Endless Wood",
            },
            {
              text: "Primeval Currents",
              value: "Primeval Currents",
            },
            {
              text: "Barking Bay",
              value: "Barking Bay",
            },
            {
              text: "Abyss Gazers",
              value: "Abyss Gazers",
            },
            {
              text: "Neo-Necropolis",
              value: "Neo-Necropolis",
            },
            {
              text: "Law of the Wildlands",
              value: "Law of the Wildlands",
            },
            {
              text: "Pararila Peninsula",
              value: "Pararila Peninsula",
            },
            {
              text: "Coup de Chat",
              value: "Coup de Chat",
            },
            {
              text: "Cherry Isles",
              value: "Cherry Isles",
            },
            {
              text: "Depths of My Heart",
              value: "Depths of My Heart",
            },
            {
              text: "Ghost Sea",
              value: "Ghost Sea",
            },
            {
              text: "Exile's Resort",
              value: "Exile's Resort",
            },
            {
              text: "Roads of Torment",
              value: "Roads of Torment",
            },
            {
              text: "Heaven's Back Alley",
              value: "Heaven's Back Alley",
            },
            {
              text: "Battle in the Bath",
              value: "Battle in the Bath",
            },
            {
              text: "Ancient Mountains",
              value: "Ancient Mountains",
            },
            {
              text: "Marine Ministry",
              value: "Marine Ministry",
            },
            {
              text: "The Devils' Academy",
              value: "The Devils' Academy",
            },
            {
              text: "The Gelatin Mines",
              value: "The Gelatin Mines",
            },
            {
              text: "Drunken Foundry",
              value: "Drunken Foundry",
            },
            {
              text: "Unearthed Artifacts",
              value: "Unearthed Artifacts",
            },
            {
              text: "Realm of Whyworry",
              value: "Realm of Whyworry",
            },
            {
              text: "Pumping Titanium",
              value: "Pumping Titanium",
            },
            {
              text: "Morningstar Isle",
              value: "Morningstar Isle",
            },
            {
              text: "In the Sleeping Forest",
              value: "In the Sleeping Forest",
            },
            {
              text: "Laboratory Island",
              value: "Laboratory Island",
            },
            {
              text: "Forgotten Graves",
              value: "Forgotten Graves",
            },
            {
              text: "Dawn of the Beginning",
              value: "Dawn of the Beginning",
            },
            {
              text: "The Happy Lucky Temple",
              value: "The Happy Lucky Temple",
            },
            {
              text: "Theatre of Fear",
              value: "Theatre of Fear",
            },
            {
              text: "Diver's City",
              value: "Diver's City",
            },
            {
              text: "Nasi-Go-Round",
              value: "Nasi-Go-Round",
            },
            {
              text: "DNA Plantation",
              value: "DNA Plantation",
            },
            {
              text: "Ancient Forest Labyrinth",
              value: "Ancient Forest Labyrinth",
            },
            {
              text: "Castle of the Sentinels",
              value: "Castle of the Sentinels",
            },
            {
              text: "Spacetime Distortion",
              value: "Spacetime Distortion",
            },
            {
              text: "Imminent Disaster",
              value: "Imminent Disaster",
            },
            {
              text: "Bikura, Harbor of Evil",
              value: "Bikura, Harbor of Evil",
            },
            {
              text: "Dead Heat Land",
              value: "Dead Heat Land",
            },
            {
              text: "Rose-Colored Road",
              value: "Rose-Colored Road",
            },
            {
              text: "Behemoth's Peak",
              value: "Behemoth's Peak",
            },
            {
              text: "Moodist Beach",
              value: "Moodist Beach",
            },
            {
              text: "Cat-Chasing Village",
              value: "Cat-Chasing Village",
            },
            {
              text: "Bazaar of the Pirate King",
              value: "Bazaar of the Pirate King",
            },
            {
              text: "Between Truth and Lies",
              value: "Between Truth and Lies",
            },
            {
              text: "人類ネコ化計画",
              value: "人類ネコ化計画",
            },
            {
              text: "古代神樹",
              value: "古代神樹",
            },
          ],
        },
        {
          category: "Legend Zero",
          chapters: [
            {
              text: "Zero Field",
              value: "Zero Field",
            },
            {
              text: "The Edge of Spacetime",
              value: "The Edge of Spacetime",
            },
            {
              text: "Cats Cradle Basin",
              value: "Cats Cradle Basin",
            },
            {
              text: "The Ururuvu Journals",
              value: "The Ururuvu Journals",
            },
            {
              text: "New World Area: Ehen",
              value: "New World Area: Ehen",
            },
            {
              text: "Cats of a Common Sea",
              value: "Cats of a Common Sea",
            },
            {
              text: "Truth in Extremes",
              value: "Truth in Extremes",
            },
            {
              text: "Demon of Deciliter Bay",
              value: "Demon of Deciliter Bay",
            },
            {
              text: "Garden of Wilted Thoughts",
              value: "Garden of Wilted Thoughts",
            },
          ]
        },
        {
          category: "Labyrinth",
          chapters: [
            {
              text: "The Grand Deep",
              value: "The Grand Deep",
            },
          ]
        },
      ],
    },
  ],
};

function filterChapterFromCategory(category) {
  // const chapterlistget = axios
  //   .get("https://onestoppress.com/api/chapterlist")
  //   .then((res) => {
  //     let dataSource = res.data;
  //     return dataSource;
  //   })
  //   .catch((err) => console.log("err: ", err));
  for (var i = 0; i < chapterlist.sampledata[0].jsonb_agg.length; i++) {
    if (chapterlist.sampledata[0].jsonb_agg[i].category === category) {
      return chapterlist.sampledata[0].jsonb_agg[i].chapters;
    } else {
      // fullchapterlist.concat(chapterlist.sampledata[0].jsonb_agg[i].chapters);
      // console.log(
      //   typeof chapterlist.sampledata[0].jsonb_agg[i].chapters,
      //   typeof chapterlist.sampledata[0].jsonb_agg[i].chapters
      // );
    }
  }
  // console.log("fullchapterlist", fullchapterlist);
  return null;
}

module.exports = filterChapterFromCategory;



// WEBPACK FOOTER //
// ./src/components-kr/utilities/chapterlist.js